import { t } from 'i18n';
import $$api from 'models/api';
import $$auth from 'models/auth';

import ModalsService from 'services/ModalsService';

const ON_BEHALF_OF_LS_KEY = 'onBehalfOf';
const ORIGINAL_NAME_LS_KEY = 'originalParticipant';
const RESUME_LINK = 'resumeLink';

const LoginAsUserService = {
    loginAsUser: async (awsId: string, linkToOpen?: string) => {
        try {
            await $$api.users.logoutUserFx(awsId);
            localStorage.setItem(
                ORIGINAL_NAME_LS_KEY,
                $$auth.$currentParticipant.map((p) => p?.full_name || '').getState(),
            );
            localStorage.setItem(ON_BEHALF_OF_LS_KEY, awsId);
            localStorage.setItem(RESUME_LINK, window.location.href);
            window.location.href = linkToOpen ?? window.location.origin;
        } catch (error) {}
    },

    isLoggedInAsUser: () => {
        return !!localStorage.getItem(ON_BEHALF_OF_LS_KEY);
    },

    getAwsId: () => {
        return localStorage.getItem(ON_BEHALF_OF_LS_KEY);
    },

    getOriginalUserName: () => {
        return localStorage.getItem(ORIGINAL_NAME_LS_KEY);
    },

    resume: async (urlAfterResume?: string) => {
        const awsId = localStorage.getItem(ON_BEHALF_OF_LS_KEY);
        if (awsId) {
            localStorage.removeItem(ON_BEHALF_OF_LS_KEY);
            localStorage.removeItem(ORIGINAL_NAME_LS_KEY);
            const resumeLink = urlAfterResume || localStorage.getItem(RESUME_LINK) || window.location.href;
            localStorage.removeItem(RESUME_LINK);
            await $$api.users.stopWorkingOnBehalfFx(awsId);
            window.location.href = resumeLink;
        }
    },

    beforeLogout: () => {
        localStorage.removeItem(ON_BEHALF_OF_LS_KEY);
        localStorage.removeItem(ORIGINAL_NAME_LS_KEY);
        localStorage.removeItem(RESUME_LINK);
    },

    signOutUserOrAdmin: () => {
        ModalsService.showModality(
            t('admin.userSignInWhileWorkingOnBehalf.title'),
            t('admin.userSignInWhileWorkingOnBehalf.text'),
            {
                confirmButton: t('admin.userSignInWhileWorkingOnBehalf.signOutUser'),
                closeButton: t('admin.userSignInWhileWorkingOnBehalf.stopWorkingOnBehalf'),
                displayCloseCross: false,
                onConfirm: async () => {
                    const awsId = LoginAsUserService.getAwsId();
                    if (awsId) {
                        await $$api.users.logoutUserFx(awsId);
                        window.location.reload();
                    }
                },
                onCancel: async () => {
                    await LoginAsUserService.resume();
                },
            },
        );
    },
};

export default LoginAsUserService;
